//Se importan los types de cada acción para usar los que se requieran
import { types } from "../../../types/types";
import axios from "axios";
import { errorAlert } from "../../ui";
import { uploadDocumentPatientToStorage, urlBase64ToFile } from "../../documents";
import generateContentProceduresCL from "./pdf-content-procedures-cl";

//Método para cambiar el estado y mostrar el mensaje de creando Receta
export const setShowAlertProcedureTrue = (show) => ({
    type: types.doctorActiveAlertProcedure,
    payload: show,
});

export const generatePdfProceduresCL = (footerDocuments, formik, proceduresToSend, dataProff, docs, setDocs) => {
    return async (dispatch) => {
        const { getReduxStore } = await import('../../../helpers/reduxInstance');
        const reduxStore = await getReduxStore();
        const urlServer = reduxStore.urlServer;

        function closeAlertMedicine(state) {
            dispatch(setShowAlertProcedureTrue(state));
        }

        dispatch(setShowAlertProcedureTrue(true));

        axios
            .post(`${urlServer}/getServerTime`, { timezone: "America/Santiago" })
            .then((response) => {
                const serverDateTime = response.data.serverTime;

                // Dividir la cadena en fecha y hora
                const [datePart, timePart] = serverDateTime.split('T');

                // Formatear la fecha
                const [year, month, day] = datePart.split('-');
                const dateGenerate = `${day}/${month}/${year}`;

                // Formatear la hora con AM/PM
                const [hour, minutes, secondsPart] = timePart.split(':');
                const seconds = secondsPart.match(/\d+/)[0];
                const hourNumber = parseInt(hour);
                const hourText = hourNumber >= 12 ? 'PM' : 'AM';
                const formattedHour = hourNumber % 12 || 12;
                const hourGenerate = `${formattedHour}:${minutes}:${seconds} ${hourText}`;

                const dataToPdf = {
                    header: true,
                    footer: true,
                    footerText: footerDocuments,
                    title: "PROCEDIMIENTOS MÉDICOS",
                    dateGenerate: dateGenerate,
                    hourGenerate: hourGenerate,
                    ...formik.values,
                    professionalCity: dataProff.city,
                    professionalAddress: dataProff.address,
                    professionalPhone: `${dataProff.codePhone}${dataProff.phone}`,
                    professionalMedicalId: dataProff.dataProf.medicalId,
                    professionalEmail: dataProff.email,
                    textProcedures: proceduresToSend
                };

                dataToPdf.content = generateContentProceduresCL(dataToPdf);

                axios
                    .post(`${urlServer}/files/createPDF`, dataToPdf)
                    .then((response) => {
                        if (response.data.status === 200) {

                            let date = new Date(formik.values.startTimeTimestamp);
                            let date_ms = new Date().getTime();
                            let date_created =
                                date.getFullYear() +
                                "_" +
                                (date.getMonth() + 1) +
                                "_" +
                                date.getDate() +
                                "_" +
                                date.getHours() +
                                "_" +
                                date.getMinutes();

                            (async () => {
                                const file = await urlBase64ToFile(
                                    response.data.binary,
                                    "documentos.pdf",
                                    "application/pdf"
                                );

                                const fileToEmail = {
                                    name: "Documentos Médicos",
                                    filename: "documentos.pdf",
                                    contentType: 'application/pdf',
                                    content: response.data.binary,
                                }

                                uploadDocumentPatientToStorage(
                                    formik,
                                    date_created,
                                    date_ms,
                                    file,
                                    fileToEmail,
                                    docs,
                                    setDocs,
                                    closeAlertMedicine,
                                    null,
                                    "report-orders-procedures",
                                    true,
                                    null,
                                    "Documentos Generados con Éxito"
                                );

                            })();
                        } else {
                            console.log(response)
                            dispatch(setShowAlertProcedureTrue(false));
                            errorAlert(response.data.err);
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        dispatch(setShowAlertProcedureTrue(false));
                        errorAlert(
                            "Error en el Servidor al generar el Informe"
                        );
                    });
            }).catch((err) => {
                console.log(err);
                dispatch(setShowAlertProcedureTrue(false));
                errorAlert(
                    "Error en el Servidor al obtener la hora"
                );
            });
    }
}